import React, { useEffect, useContext } from 'react';
import './App.css';
import TitleBar from './components/TitleBar/TitleBar';
import PoweredBar from './components/PoweredBar/PoweredBar';
import OfflineTopBar from './components/OfflineTopBar/OfflineTopBar';
import OneComponent from './OneComponent';
import UserContext from './context/UserContext';

function App() {
  const { owner_online } = useContext(UserContext) || {};

  useEffect(() => {
    // any effects
  }, []);

  return (
    <div className="ecd-widgetOuter">
      <div className="ecd-widgetInner-dark">
        {owner_online ? <TitleBar /> : <OfflineTopBar />}
        <OneComponent />
        <PoweredBar />
      </div>
    </div>
  );
}

export default App;
